
import React from 'react'
import '../styles.scss'
import { useTranslation } from 'react-i18next';
import { CardInfo } from '../../../Portfolio_R/SummaryCharts/components/CardInfo';
import SmallTable from '../components/SmallTable/SmallTable';
import { Step, StepLabel, Stepper } from '@material-ui/core';
import CustomStepIcon from '../components/CustomStepIcon/CustomStepIcon';
import BarChartProjectReport from '../components/BarChartProjectReport/BarChartProjectReport';
import LinearProjectReport from '../components/LinearProjectReport/LinearProjectReport';
import NomenclatureItem from '../components/NomenclatureItem/NomenclatureItem';
import ExecutionProgress from '../components/ExecutionProgress/ExecutionProgress';
import { useNumberFormatter } from '../../../../hooks/useNumberFormatter';
import ChartProgressBarReport from '../../../Portfolio_R/SummaryCharts/components/ChartProgressBarReport';
import { dataProgress, dataSteps, evolutionDisbursmentProgress } from './Common/NomenclatureItems';
import { HeaderPmr } from '../components/HeaderPmr/HeaderPmr';
import { capitalizeFirstLetter } from '../../../../services/stringUtil';
import { EXTENDED_REPORT_KEY } from '../utils/Constants/ProjectReportConstants';
import { mapGeneralInfoInDataSource } from '../utils/Helpers/MapperHelper';
import { NoContentView } from '../components/NoContentView/NoContentView';

export const PMRProjectSummary = ({ data }) => {
    const { t } = useTranslation();
    const { formatNumber } = useNumberFormatter();

    const divisorView = 1000000;
    const dataSource = data.typeReport === EXTENDED_REPORT_KEY ? mapGeneralInfoInDataSource(data) : data;
    dataSource.baseInformation = data.typeReport !== EXTENDED_REPORT_KEY ? dataSource.baseInformacion : dataSource.baseInformation;
    dataSource.projectMilestones = data.typeReport !== EXTENDED_REPORT_KEY ? dataSource.projectMilestones : dataSource.milestones;
    dataSource.financialInformation = data.typeReport !== EXTENDED_REPORT_KEY ? dataSource.financialinformation : dataSource.financialInformation;

    const {
        environmentalSocial,
        baseInformation,
        projectMilestones,
        financialInformation,
        evolution
    } = dataSource;

    const pmRperformance = evolution.pmRperformance.map(({ yearDate, pmrClassification }) => ({
        yearDate,
        pmrClassification
    }));

    return (
        <section id='report-main'>
            <HeaderPmr data={dataSource} />

            <article className="content-project-report">
                {/* First column */}
                <section className='content-base-information'>
                    <div className='objectives-project-report'>
                        <h3 className="chart-title">{t('objective')}</h3>
                        <p className="objective-text">{dataSource.objectiveName}</p>
                    </div>

                    <div className='social_enviromment-project-report'>
                        <h3 className="chart-title">{capitalizeFirstLetter(t('environmental_and_social'))}</h3>

                        <div className='social_enviromment-project-report-content'>
                            <div className='social_enviromment-category'>
                                <span className='subtitle-min-font'>{t('category')}</span>
                                <p>{environmentalSocial.category}</p>
                            </div>
                            <div className='social_enviromment-risk'>
                                <span className='subtitle-min-font'>{t('risk')}</span>
                                <p><span
                                    className="bullet"
                                    style={{
                                        backgroundColor: environmentalSocial.risk.color,
                                        display: 'inline-flex',
                                        marginLeft: 5,
                                        marginRight: 5,
                                    }}
                                ></span> {t(environmentalSocial.risk.label)}</p>
                            </div>
                            <div className='social_enviromment-performance'>
                                <span className='subtitle-min-font'>{t('performance')}</span>
                                <p><span
                                    className="bullet"
                                    style={{
                                        backgroundColor: environmentalSocial.performance.color,
                                        display: 'inline-flex',
                                        marginLeft: 5,
                                        marginRight: 5,
                                    }}
                                ></span> {t(environmentalSocial.performance.label)}</p>
                            </div>
                        </div>
                    </div>

                    <div className="team_leader-project-report">
                        <h3 className="chart-title">{t('role_id_2') + ' ' + t('bid')}</h3>
                        <p>{baseInformation.bidTeamLeader || 'N/A'}</p>
                    </div>

                    <div className="counterpart-project-report">
                        <h3 className="chart-title">{t('team_executing_unit')}</h3>

                        <span className='counterpart-proyect-subtitle'>{t('borrower')}</span>
                        <p>{baseInformation.borrower || 'N/A'}</p>

                        <span className='counterpart-proyect-subtitle'>{t('executor')}</span>
                        <p>{baseInformation.executingAgency || 'N/A'}</p>
                    </div>
                </section>

                {/* Second column */}
                <div className="project_milestone-project-report">
                    <h3 className="chart-title">{t('one_pager_report.project_milestones')}</h3>

                    <div className="chart-content">
                        <CardInfo title={t('approval')} data={projectMilestones.dateApproval} />
                        <CardInfo title={t('effectiveness')} data={projectMilestones.dateEffectiveness} />
                        <CardInfo title={t('eligibility')} data={projectMilestones.dateEligibility} />
                        <CardInfo title={t('first_disbursement')} data={projectMilestones.dateFirstDisbursement} />
                        <CardInfo title={t('last_disbursement')} data={projectMilestones.dateLastDisbursement ? `${projectMilestones.dateLastDisbursement} (${capitalizeFirstLetter(t('original'))})` : '-'} />
                        <CardInfo title={`${t('extension')}: ${projectMilestones.monthExtension || 0} ${t('months')}`} data={`${projectMilestones.dateExtension} (${capitalizeFirstLetter(t('current'))})`} />
                    </div>

                    <div>
                        <h3 className="chart-title">{capitalizeFirstLetter(t('temporary_advance_title').toLowerCase())}</h3>
                        <ExecutionProgress
                            completed={projectMilestones.executionPlan.elapsedPercent}
                            totalTime={projectMilestones.executionPlan.totalTime}
                            initialMonths={projectMilestones.executionPlan.legalValidityMounth}
                            initialDate={projectMilestones.executionPlan.datelegalValidity}
                            pendingMonths={projectMilestones.executionPlan.lastCurrentDisbursementPeriodMounth}
                            endingDate={projectMilestones.executionPlan.datelastCurrentDisbursementPeriod} />
                    </div>
                </div>

                <div className="evolution-project-report">
                    <div className='c-bar-chart'>
                        <h3 className="chart-title">{t('evolution')}</h3>

                        <div className='c-title-nom'>
                            <span>{t('performance_pmr_title')}</span>
                            <NomenclatureItem data={dataSteps} />
                        </div>

                        <div className="c-stepper">
                            <Stepper alternativeLabel activeStep={1}>
                                {pmRperformance.map((step) => (
                                    <Step key={step.yearDate}>
                                        <StepLabel
                                            StepIconComponent={(props) => (
                                                <CustomStepIcon {...props} classification={step.pmrClassification} />
                                            )}
                                        >
                                            {step.yearDate}
                                        </StepLabel>
                                    </Step>
                                ))}
                            </Stepper>
                        </div>

                        <div className='evolution-project-report-header'>
                            <span className="chart-subtitle">{t('disbursements_and_projections_title')}</span>
                            <NomenclatureItem data={evolutionDisbursmentProgress} />
                        </div>
                        <BarChartProjectReport chart={evolution.disbursementsProjectionsEvolution} />
                    </div>
                </div>

                {/* Third column */}
                <div className="financial_info-project-report">
                    <div id='financial_info_content'>
                        <h3 className="chart-title">{t('info_financial')}</h3>
                        <span>{t('one_pager_report.current_balances')}</span>
                        <SmallTable
                            showHeaders
                            itemTitle={t('bid')}
                            original={formatNumber(financialInformation.originalAmountBID / divisorView)}
                            cancel={formatNumber(financialInformation.cancelledAmountBID / divisorView)}
                            adjusted={formatNumber(financialInformation.adjustedAmountBID / divisorView)}
                            current={formatNumber(financialInformation.currentBID / divisorView)}
                        />
                        <SmallTable
                            itemTitle={t('local')}
                            original={formatNumber(financialInformation.originalAmountLocal / divisorView)}
                            cancel={formatNumber(financialInformation.cancelledAmountLocal / divisorView)}
                            adjusted={formatNumber(financialInformation.adjustedAmountLocal / divisorView)}
                            current={formatNumber(financialInformation.currentLocal / divisorView)}
                        />
                        <SmallTable
                            itemTitle={t('one_pager_report.cofinancing')}
                            original={formatNumber(financialInformation.originalAmountCofinancing / divisorView)}
                            cancel={formatNumber(financialInformation.cancelledAmountCofinancing / divisorView)}
                            adjusted={formatNumber(financialInformation.adjustedAmountCofinancing / divisorView)}
                            current={formatNumber(financialInformation.currentAmountCofinancing / divisorView)}
                        />
                    </div>

                    <div id='financial_progress_report'>
                        <span>{t('financial_advance')}</span>
                        <ChartProgressBarReport
                            completed={financialInformation.financialAdvance.disbursedPercent}
                            totalAmount={financialInformation.financialAdvance.currentApprovedAmount}
                            disbursmentAmount={financialInformation.financialAdvance.disbursedAmount}
                            completedLabel={capitalizeFirstLetter(t('done'))}
                            pendingLabel={t('pending')} />
                    </div>


                    <div id='disbursements_summary'>
                        <span>{t('disbursements')}</span>
                        <div className="chart-content">
                            <CardInfo
                                key={'gcm_no_disbursements_one_year'}
                                title={t('gcm_no_disbursements_one_year')}
                                data={financialInformation.financialAdvance.lastDisbursementDate} />
                            <CardInfo
                                key={'next_projected_disbursement'}
                                title={t('next_projected_disbursement')}
                                data={financialInformation.financialAdvance.nextProjectedDisbursement || 'N/A'} />
                            <CardInfo
                                key={'disbursement_minimum'}
                                title={t('disbursement_minimum')}
                                data={formatNumber(financialInformation.financialAdvance.minimumJustifyAdvance)}
                                units={t('dolar_sign')} />
                        </div>
                    </div>

                    <div className='component-advance-summary'>
                        <div className='c-title-nom'>
                            <span>{t('one_pager_report.advance_per_component')}</span>
                            <NomenclatureItem data={dataProgress} />
                        </ div>
                        {
                            financialInformation.advanceComponent.length ? financialInformation.advanceComponent.slice(0, 6).map((item, index) => (
                                <div className="component-advance-content" key={'component-advance-content_' + index}>
                                    <LinearProjectReport
                                        title={item.nameComponent}
                                        completed={item.justifiedPercent}
                                        pending={item.pendingPercent}
                                        initialAmount={'$ ' + formatNumber(item.justifiedAmount)}
                                        pendingAmount={'$ ' + formatNumber(item.pendingAmount)} />
                                </div>
                            ))
                                : <NoContentView title={t('last_no_information')} />
                        }
                    </div>
                </div>
            </article>
        </section>
    );
};
